<template>
  <div class="pages">
    <headerView  :show-bg="true" :bg-type="2"></headerView>
    <div id="container"></div>

    <div class="store-wrap">
      <el-input :placeholder="$t('store_input')" @keyup.enter.native="handleFilter" v-model="formData.storesName" >
        <el-button slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
      </el-input>

      <div style=" margin-top: 16px;" v-if="showList">
        <div class="rowCenter positionBox" v-if="latitude && longitude">
          <div>{{$t('store_locate')}}</div>
          <button class="btn" @click="getLocation">{{$t('store_locate_btn')}}</button>
        </div>
        <ul class="gray-scroll-bar storeList " v-infinite-scroll="loadStore" infinite-scroll-distance="3" >
          <li class="pointer storeItem" v-for="(item,index) in list" :key="index" @click="bindStore(item)">
            <div class="title">{{item.name}}</div>
            <div class="address">{{item.addressContent}}</div>
            <div class="info">
              <span v-if="item.phone">{{$t('store_phone')}}: {{item.phone}}</span>
              <span class="space">|</span>
              <span v-if="item.businessStartTime">{{$t('store_time')}}: {{item.openTime}}</span>
            </div>
          </li>
          <li v-if="(!list || list.length==0) && stateSche!=1" style="text-align: center;line-height: 100px;">{{$t('nodata')}}</li>
        </ul>
        <p v-if="stateSche==1" class="text-center">{{$t('load_txt')}}</p>

      </div>
      <div class="center showMore" @click="showList=!showList">
        <i :class="showList?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
      </div>

    </div>
  </div>
</template>

<script>
var map = null;
import headerView from "@/components/Header";
import {getStoresList } from "@/request/api";
import citysEN from "@/assets/city_en.json";
export default {
  name: "store",
  components: {headerView},
  data() {
    return {
      stateSche: 1, //加载进度 0:不显示加载 显示数据，1：正在加载，2：没有更多数据，暂无相关数据，3：加载失败
      list: [],
      pageCount:0,
      total: 0,
      listQuery: {
        Page: 1, //当前页
        Limit: 20 //每页总条数
      },
      formData: {
        storesName: "", 
      },
      showList:false,

      latitude: null,
      longitude: null,
      markers: [],
      infoWin: null,

    
      marker_1: require("../../assets/images/marker_1.png"),
      marker_2: require("../../assets/images/marker_2.png")
    };
  },
  mounted() {
    this.getLocation();

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://map.qq.com/api/js?v=2.exp&key=KX7BZ-MQ46V-6OAPN-5QISF-JOGXK-CFFJN&callback=initMap";
    document.body.appendChild(script);
    window.initMap = () => {
      this.initMap();
    };
  },
  created() {
     this.getDataList();
  },
  methods: {

  getDataList() {
      let that = this;
      that.stateSche = 1;
      const para = {
        pageParm: {
          page: that.listQuery.Page,
          limit: that.listQuery.Limit,
          keyword: "",
          field: "",
          sort: 0
        },
        state:1,
        isCanDispatch:1,
        // isEnable:1,
        storesName: that.formData.storesName||"",
      };
      getStoresList(para).then(res => {
        if (res.code == 200) {
          if (res.data.data != null && res.data.data.length > 0) {
            let list=res.data.data;
            let fnopenTime=function(time){
              if(time){
                time=time.split(" ")[1].split(":")
                return time[0]+":"+time[1]
              }
              return "";
            }
            // let fn_name=function(name){
            //   if(name){
            //     name=(citysEN(item.districtId)||{}).name_en||""
            //   }
            //   return name
            // }
            let fn_item=function(item){
                item.openTime=fnopenTime(item.businessStartTime)+"-"+fnopenTime(item.businessEndTime);
                // item.masterUrlStr=item.masterUrl?JSON.parse(item.masterUrl)[0]:"";
                 item.masterUrlStr=item.masterUrl;
               return item
            }
            if(this.$store.getters.language=="en"){
              list.forEach(item=>{
                item=fn_item(item);
                item.addressContent=citysEN[item.cityId].name_en
                item.addressContent=item.address+citysEN[item.districtId].name_en+citysEN[item.cityId].name_en+citysEN[item.provinceId].name_en;
              })
            }else{
              list.forEach(item=>{
                item=fn_item(item);
                item.addressContent=item.provinceName+item.cityName+item.districtName+item.address;
              })
            }
           
            that.list = res.data.data;
            if(map){
               that.showMarkers();
            }
            that.total = res.data.dataCount;
            that.pageCount = res.data.pageCount;
            that.stateSche = 0;
          } else {
            that.list = null;
            that.stateSche = 2;
          }
        } else if (res.code == 204) {
          that.list = null;
          that.stateSche = 2;
        } else {
          that.list = null;
          that.stateSche = 3;
        }
      });
    },
    handleFilter(){
      this.showList=true;
      this.listQuery.Page = 1;
      this.getDataList();
    },

    getLocation() {
      let that = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            that.latitude = position.coords.latitude;
            that.longitude = position.coords.longitude;
            that.setMapCenter();
          },
          error => {
            let errTxt = "";
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errTxt = "用户拒绝了地理定位请求。";
                break;
              case error.POSITION_UNAVAILABLE:
                errTxt = "位置信息不可用。";
                break;
              case error.TIMEOUT:
                errTxt = "获取用户位置的请求超时。";
                break;
              case error.UNKNOWN_ERROR:
                errTxt = "发生未知错误。";
                break;
            }
            console.log(error, errTxt);
          }
        );
      } else {
        console.log("此浏览器不支持地理定位。");
      }
    },
    //地图
    initMap() {
      let that = this;
      var container = document.getElementById("container");
      map = new qq.maps.Map(container, {
        // draggableCursor: "crosshair",
        zoom: 7
      });
      new qq.maps.Label({
        map: map,
        offset: new qq.maps.Size(15, -12),
        draggable: false,
        clickable: false
      });
      that.setMapCenter();
      if(this.list && this.list.length){
        that.showMarkers();
      }
      
    },

    setMapCenter() {
      let that = this;
      if (map) {
        let latitude = this.latitude || 23.277476;
        let longitude = this.longitude || 113.315833;
        var center = new qq.maps.LatLng(latitude, longitude);
        map.setCenter(center);
        if (this.latitude && this.longitude) {
          var anchor = new qq.maps.Point(10, 10),
            size = new qq.maps.Size(24, 24),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage(that.marker_1, size, origin, anchor);
          new qq.maps.Marker({
            icon: icon,
            position: center,
            map: map
          });
        }
      }
    },
    showMarkers() {
      let that = this;
      this.clearOverlays(that.markers); //清除marker
      if (that.infoWin) {
        that.infoWin.close();
        that.infoWin = null;
      }

      var pois = this.list;
      that.infoWin = new qq.maps.InfoWindow({
        map: map
      });
      for (var i = 0, l = pois.length; i < l; i++) {
        (function(n) {
          var anchor = new qq.maps.Point(15, 3),
            size = new qq.maps.Size(30, 30),
            origin = new qq.maps.Point(0, 0),
            icon = new qq.maps.MarkerImage(that.marker_2, size, origin, anchor);

          var marker = new qq.maps.Marker({
            icon: icon,
            position: new qq.maps.LatLng(
              pois[n].latitude,
              pois[n].longitude
            ),
            map: map
          });
          //markStoreImg

          marker.setTitle(i + 1);
          that.markers.push(marker);
          //点击检索出来的结果
          qq.maps.event.addListener(marker, "click", function() {
            that.showList=false;
            that.infoWin.open();
            var htmlstr=`<div style="color: rgba(18, 21, 26, 0.6);width: 402px; padding: 16px 0;">
                        <img
                          style="border-radius: 8px;width: 100%;height: 226px;"
                          src="${pois[n].masterUrlStr}"
                          alt
                        />
                        <div style=" color: #12151a;font-size: 16px;margin-top: 8px;">${pois[n].name}</div>
                        <div style="line-height: 20px;margin: 8px 0 6px;word-break: break-all;">${pois[n].addressContent}</div>
                        <div class="info">
                          <span>${that.$t('store_phone')}: ${pois[n].phone}</span>
                          <span style="margin: 0 10px;">|</span>
                          <span>${that.$t('store_time')}: ${pois[n].openTime}</span>
                        </div>
                      </div>`
             that.infoWin.setContent(htmlstr)
            that.infoWin.setPosition(
              new qq.maps.LatLng(pois[n].latitude, pois[n].longitude)
            );
          });
        })(i);
      }
    },
    //清除地图上的marker
    clearOverlays(overlays) {
       let overlay;
        while (overlays && overlays.length>0) {
          overlay= overlays.pop()
          overlay.setMap(null);
        }
    },

   bindStore(item){
    let that=this;
        that.showList=false;
        that.infoWin.open();
        var htmlstr=`<div style="color: rgba(18, 21, 26, 0.6);width: 402px; padding: 16px 0;">
                    <img
                      style="border-radius: 8px;width: 100%;height: 226px;"
                      src="${item.masterUrlStr}"
                      alt
                    />
                    <div style=" color: #12151a;font-size: 16px;margin-top: 8px;">${item.name}</div>
                    <div style="line-height: 20px;margin: 8px 0 6px;word-break: break-all;">${item.addressContent}</div>
                    <div class="info">
                      <span>${that.$t('store_phone')}: ${item.phone}</span>
                      <span style="margin: 0 10px;">|</span>
                      <span>${that.$t('store_time')}: ${item.openTime}</span>
                    </div>
                  </div>`
          that.infoWin.setContent(htmlstr)
        that.infoWin.setPosition(
          new qq.maps.LatLng(item.latitude, item.longitude)
        );

   },


    loadStore(){
      if(this.stateSche==1 || this.stateSche==2 || this.pageCount>=this.listQuery.Page){
        return
      }
      this.listQuery.Page = this.listQuery.Page+1;
      this.getDataList();
    },
  }
};
</script>

<style scoped lang="scss">
#container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.store-wrap {
  position: absolute;
  top: 15%;
  left: 10%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06), 0 15px 15px 0 rgba(0, 0, 0, 0.05),
    0 34px 21px 0 rgba(0, 0, 0, 0.03), 0 61px 24px 0 rgba(0, 0, 0, 0.01),
    0 96px 27px 0 transparent;
  padding: 24px;
  background-color: rgb(246 247 248);
  border-radius: 8px;
  width: 450px;
  max-height: 80%;
  overflow: hidden;
  z-index: 999;
  .storeList {
    overflow: auto;
    height: 800px;
  }
  .storeItem {
    margin-bottom: 8px;
    padding: 16px;
    border-radius: 8px;
    color: rgba(18, 21, 26, 0.6);
    font-size: 14px;
    .title {
      color: #12151a;
      font-size: 16px;
    }
    .address {
      line-height: 20px;
      margin: 8px 0 6px;
    }
    .space {
      margin: 0 10px;
    }
  }

  .storeItem:hover {
    background-color: #fff;
  }
}



.gray-scroll-bar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.gray-scroll-bar::-webkit-scrollbar-thumb {
  background-color: rgba(18, 21, 26, 0.1);
  border-radius: 3px;
}
.gray-scroll-bar::-webkit-scrollbar-track {
  border-radius: 10px;
}

.positionBox{
  padding: 0 16px 16px;
      color: rgba(18,21,26,.6);
      line-height: 20px;
      .btn{
  margin-left: 10px;
  min-width: 80px;
}

}

.showMore{
      font-size: 24px;
    font-weight: 700;
    color: #999;
    margin-top: 14px;
    cursor: pointer;
}
@media (max-width: 550px) {
.store-wrap{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    top: auto;
     .storeList {
    overflow: auto;
    height: 500px;
  }
}

}


</style>


